import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import { MaintenanceComponent } from './shared/maintenance/maintenance.component';
import { BrochureRedirectComponent } from './shared/brochure-redirect/brochure-redirect.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';

/**
 * Created by keithcoughtrey on 18/05/17.
 *
 * The marketing/content pages (home, about, privacy, terms, etc.) now live on the
 * external brochure site. The app root and any unmatched route redirect there via
 * BrochureRedirectComponent; the functional areas below remain in this app.
 */
const routes: Routes = [
  { path: 'maintenance',  component: MaintenanceComponent },
  { path: 'notify', loadChildren: () => import('./notify/notify.module').then(m => m.NotifyModule) },
  { path: 'portal', loadChildren: () => import('./portal/portal.module').then(m => m.PortalModule) },
  { path: 'planner', loadChildren: () => import('./planner/planner.module').then(m => m.PlannerModule) },
  { path: '',  component: BrochureRedirectComponent },
  { path: '**',  component: NotFoundComponent },
];
@NgModule({
  imports: [ RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
